import Image from 'next/image';
import { useState } from 'react';

import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

interface ZoraTokenChainImageProps {
  chainId: number;
  logoUrl: string;
  tokenName: string;
  onClick?: () => void;
  className?: string;
}

export const ZoraTokenChainImage = ({
  chainId,
  logoUrl,
  tokenName,
  onClick,
  className,
}: ZoraTokenChainImageProps) => {
  const [hasError, setHasError] = useState(false);

  return (
    <div
      className={`relative ${!hasError ? 'cursor-pointer transition-transform duration-200 hover:scale-105' : ''} ${className || ''}`}
      onClick={hasError ? undefined : onClick}
    >
      <div className="w-full h-full overflow-hidden rounded-lg">
        <Image
          src={hasError ? '/images/not-found.png' : logoUrl}
          alt={tokenName}
          width={500}
          height={500}
          className="object-cover w-full h-full"
          onError={() => setHasError(true)}
        />
      </div>
      <div className="absolute -bottom-2 -right-2 rounded-[8px] border-2 border-token-gray-200">
        <ChainAvatar chainId={chainId} alt="Chain" size={20} />
      </div>
    </div>
  );
};
